/**
 * Normalizes phone strings for parsing/formatting.
 * Handles WhatsApp prefixes and Mexico mobile prefix (+521 / 521 -> +52 / 52).
 */
export const normalizePhoneNumber = (phone?: string): string =>
    String(phone || '')
        .replace(/whatsapp:/gi, '')
        .trim()
        .replace(/\s/g, '')
        .replace(/^\+521/, '+52')
        .replace(/^521/, '52');
